import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { IResetPasswordState } from '../../interfaces/states/IResetPasswordState';

const initialState: IResetPasswordState = {
  showResetPassword: false,
  showResetSuccessModal: false,
};
class ResetPasswordReducer extends ImmerReducer<IResetPasswordState> {
  public setResetPassword(showResetPassword: boolean): void {
    this.draftState.showResetPassword = showResetPassword;
  }
  public cancelReset(): void {
    this.draftState.showResetPassword = false;
    this.draftState.showResetSuccessModal = false;
  }
  public showResetSuccessModal(toggle: boolean): void {
    this.draftState.showResetSuccessModal = toggle;
  }
}

export const ResetPasswordActions = createActionCreators(ResetPasswordReducer);
export const ResetPasswordFunction = createReducerFunction(ResetPasswordReducer, initialState);
